<div
  class="heading skin-detail-heading"
  (resize)="handleResize($event)"
>
  @if (canGoBack()) {
    <app-button2
      appearance="secondary-ghost"
      size="s"
      [ariaLabel]="S['Go back']"
      (click)="handleGoBack()"
    >
      <app-icon name="chevron-left" />
    </app-button2>
  }

  <app-input
    class="input"
    appearance="sapphire-inline"
    [inputFormControl]="form.controls.title"
    placeholder="New Folder"
    [errorPlaceholder]="'Add title'"
    [withErrors]="submitted"
    size="s"
  />

  <div class="icons">
    <div [appPreventDirtyClick]="dirtyFormRef" class="contents">
      <!-- [MUST-002] 'Bug' debug quick-action hidden per task; uncomment to re-enable
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="bug"
        [active]="selectedTab === 'debug'"
        matTooltip="Debug"
        (onClick)="selectedTab = 'debug'"
      />
      -->

      @if (!contracted) {
        <stch-quick-action
          appearance="sapphire-toggle"
          size="m"
          icon="sapphire-archive2"
          [active]="form.controls.archived.value"
          [matTooltip]="form.controls.archived.value ? Labels.RestoreFromArchive : Labels.Archive"
          [disabled]="!sheetFolder?.id"
          (onClick)="archive()"
        />

        <stch-trash-action [disabled]="!sheetFolder?.id" [deleted]="form.controls.deleted.value" (onClick)="delete()" />
      }

<!-- SBUX-785 v1: containers are not shareable (only leaf entities). Re-enable later.
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-share"
        matTooltip="Share"
        [disabled]="!sheetFolder?.id"
        [stchShareContextMenu]="sheetFolder"
        [stchShareContextMenuDisabled]="!sheetFolder?.id"
      />
      -->

      <app-button
        appearance="sapphire-secondary-ghost"
        size="xs"
        icon="sapphire-ellipsis"
        [matTooltip]="S['More options']"
        [ariaLabel]="S['More options']"
        [disabled]="!sheetFolder?.id"
        [appSheetFolderContextMenu]="sheetFolder"
        [appSheetFolderContextMenuDisabled]="!sheetFolder?.id"
        appSheetFolderContextMenuMode="popover"
        [printEnabled]="true"
      />
    </div>

    @if (showCloseButton) {
      <app-button
        appearance="sapphire-secondary-ghost"
        size="xs"
        icon="sapphire-close"
        [ariaLabel]="S['Close']"
        (click)="handleClose()"
      />
    }
  </div>
</div>

<app-stitch-timestamps class="block" [createdAt]="sheetFolder?.createdAt" [updatedAt]="sheetFolder?.updatedAt" />

<div class="tabs skin-detail-tabs">
  <app-tabs
    appearance="sapphire"
    [values]="tabsWithCounts()"
    [(value)]="selectedTab"
    size="m"
  />

  <div class="filler"></div>

  <!-- [MUST-001] 'Assign' button hidden per task; uncomment to re-enable

  <app-button appearance="sapphire-secondary" size="xs" label="Assign" />

  -->
  <stch-knowledge-button
    [active]="displayKnowledge"
    (click)="showKnowledge()"
  />
</div>

@if (form) {
  <div
    class="form"
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDrop($event)"
  >
    <div class="drop-area-border"></div>

    @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
      <app-entity-hub-search [contactId]="sheetFolder?.id" />
    }

    <div class="form-heading">
      <div class="form-heading-nav">
        <div class="form-heading-nav-separator"></div>

        @if (selectedTab === 'sheetFolder') {
        }

      </div>

      @if (displayKnowledge) {
        <div class="form-heading-nav-underline"></div>
      }

      <!-- One Knowledge box, rows in the skin's order: Knots · Tags · Connections. On the Stitch tab the rows are
           the knowledge hub's facets (#2481), read-only, and hidden without hub access. -->
      <div
        class="form-knowledge"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
      >
        <app-knots
          class="form-knots"
          [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
          [stitchItems]="sheetFolder | toArray"
          [control]="form.controls.knots"
          [stateKey]="StateKey.knotsList"
          [withControls]="selectedTab !== 'stitch'"
          [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
          [hubEntityUid]="sheetFolder?.id"
        />

        <app-tags
          class="form-tags"
          [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
          [stitchItems]="[sheetFolder]"
          [control]="form.controls.tags"
          [stateKey]="StateKey.tagsList"
          [withControls]="selectedTab !== 'stitch'"
          [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
          [hubEntityUid]="sheetFolder?.id"
        />

        <app-connections
          class="form-knots"
          [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
          [stitchItems]="[sheetFolder]"
          [control]="form.controls.connections"
          [stateKey]="StateKey.connectionsList"
          [withControls]="selectedTab !== 'stitch'"
          [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
          [hubEntityUid]="sheetFolder?.id"
        />
      </div>
    </div>

    @if ((selectedTab !== 'stitch' || (permissionsLoaded() && !hasKnowledgeHubAccess()))) {
      <!-- stitch-app-shell ContainerItems: the list's sort & filter on a bar of its own right above the list, on
           the far right over a 1px line, so it reads as the list's (Johanna, 2026-10-21; it sat in the tab row). -->
      @if (selectedTab === 'sheetFolder') {
        <div class="container-list-bar">
          <app-context-menu-state-indicator svgIcon="filters" appSheetsListContextMenu />
        </div>
      }
      <app-scroll
        class="form-scroll"
        (top)="displayScrollShadow = !$event"
      >
        @if (displayScrollShadow) {
          <div class="form-scroll-shadow"></div>
        }

        @switch (selectedTab) {
          @case ('sheetFolder') {
            <app-sheets-list
              [filters]="sheetsFilters"
              (openSheet)="openWorkbook($event)"
              (clickSheet)="handleClickItem($event)"
              (doubleClickSheet)="handleDblClickItem($event)"
            />
          }

          @case ('details') {
            <div
              class="form-kit"
              [class.contracted]="contracted"
            >
              <section class="form-kit-section">
                @if(false) { <!-- HIDDEN FOR VERSION 1-->
                  <div class="form-kit-field">
                    <span class="form-kit-label">Parent Folder</span>
                    <app-autocomplete-input
                      appearance="sapphire-outline"
                      placeholder="Parent Folder"
                      [suggestions]="parentSuggestions"
                      [inputFormControl]="form.controls.parentId"
                      size="s"
                      [withErrors]="submitted"
                      [validationMessages]="{
                        circular: 'Circular dependency',
                        deep: 'Too deep'
                      }"
                      [withClear]="true"
                    />
                  </div>
                }
              </section>

              <section class="form-kit-section">
                <stch-item-description-field
                  data-testid="sheet-folder-details-description"
                  [control]="form.controls.description"
                  [item]="sheetFolder"
                  [tagsControl]="form.controls['tags']"
                  [knotsControl]="form.controls['knots']"
                />
              </section>
            </div>
          }

          @case ('attachments') {
            <app-attachments-list
              class="form-attachments"
              [stitchItem]="stitchItem"
              [inputControl]="form.controls.uploads"
              [contextMenuStateVariant]="attachmentsMenuStateVariant"
              (listStateChange)="attachmentsListState = $event"
              (onClickItem)="handleClickItem($event)"
              (onDblClickItem)="handleDblClickItem($event)"
              (uploading)="onUploadingChange($event)"
            />
          }

          <!-- One case for both: ngSwitch rendered every matching case, @switch renders the first. -->
          @case ('stitch') {
            <app-context-menu-state-indicator
              class="block ml-auto w-fit mt-5 mr-4"
              svgIcon="filters"
              appStitchListContextMenu
              (appStitchListContextMenuChange)="stitchListState = $event"
            />

            <app-linked-info-list
              class="form-linked-info"
              [stitch]="sheetFolder"
              [state]="stitchListState"
              (clickStitchItem)="handleClickItem($event)"
              (dblClickStitchItem)="handleDblClickItem($event)"
            />
          }

          @case ('comments') {
            <stch-comments
              class="form-linked-info"
              [stitch]="sheetFolder"
            />
          }

          @case ('debug') {
            <stch-json-viewer
              [json]="sheetFolder?.debug"
            />
          }
        }
      </app-scroll>
    }

    @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
      <app-stitch-hub
        [stitch]="sheetFolder"
        (clickStitchItem)="handleClickItem($event)"
        (dblClickStitchItem)="handleDblClickItem($event)"
      />
    }

    <stch-save-cancel-panel
      [enabled]="!pristine"
      [uploading]="isUploading()"
      (onCancel)="handleCancel()"
      (onSave)="handleSubmit()"
    />

  </div>
}

<!-- stitch-app-shell breadcrumbs footer in the main view, as on every detail page. -->
@if (navigation.enabled && stitchItem?.id) {
  <app-detail-breadcrumbs
    [crumbs]="breadcrumbs()"
    [status]="form.controls.archived.value ? 'Archived' : form.controls.deleted.value ? 'Trash' : undefined"
  />
}
